import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { User } from "../models/user";
import { Permissions } from "../models/permissions";
import { Token } from "../models/token";

@Injectable()
export class AuthService {
    private permissions:Permissions;

    constructor( private http : HttpClient, private router : Router ){ }

    async LoadActualUser() : Promise<User> {
        return this.http.get<User>("/api/auth/user")
            .toPromise();
    }

    getActualUser() : User {
        return JSON.parse(localStorage.getItem("user"));
    }

    isAuthenticated() : boolean {
        return localStorage.getItem("token") && localStorage.getItem("user") && localStorage.getItem("permissions") ? true : false;
    }

    getPermissions() : Permissions {
        return JSON.parse(localStorage.getItem('permissions'));
    }

    is(role:string) : boolean {
        let permissions = this.getPermissions();

        for(var i = 0; i < permissions.roles.length; i++) {
            if(permissions.roles[i].name == role || permissions.roles[i].name == 'root') {
                return true;
            }
        }

        return false;
    }

    isExactly(role:string) : boolean {
        let permissions = this.getPermissions();

        for(var i = 0; i < permissions.roles.length; i++) {
            if(permissions.roles[i].name == role) {
                return true;
            }
        }

        return false;
    }

    isNot(role:string) : boolean {
        let permissions = this.getPermissions();

        for(var i = 0; i < permissions.roles.length; i++) {
            if(permissions.roles[i].name == role) {
                return false;
            }
        }

        return true;
    }

    has(ability:string) : boolean {
        let permissions = this.getPermissions();

        for(var i = 0; i < permissions.all.length; i++) {
            if(permissions.all[i].name == ability) {
                return true;
            }
        }

        return false;
    }

    can(ability:string) : boolean {
        return this.has('*') || this.has(ability);
    }

    logout() : void {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("permissions");
        this.router.navigate(['/']);
    }

    async login(email, password) : Promise<Token> {
        if(this.isAuthenticated()) {
            this.router.navigate(['/principal']);
        }

        return this.http.post<Token>("/api/auth/login", {
            username: email,
            password: password,
        })
        .toPromise();
    }

    async changePassword(actual_password, password, password_confirmation) : Promise<void> 
    {
        await this.http.post<void>('/api/auth/user/changepassword', {
            actual_password, password, password_confirmation
        }).toPromise();
    }
}